import { NgModule } from '@angular/core';
import { PublicRoutingModule } from './public-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PublicComponent } from './public.component';
import { LoginComponent } from './login/login.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { PdfPageComponent } from './pdf-page/pdf-page.component';
import { HandlerAuthComponent } from './handler/handler-auth.component';

@NgModule({
  declarations: [
    PublicComponent, 
    LoginComponent, 
    RecoverPasswordComponent, 
    PdfPageComponent,
    HandlerAuthComponent
  ],
  imports: [
    SharedModule,
    PublicRoutingModule,
  ],
  entryComponents: [
    RecoverPasswordComponent
  ]
})

export class PublicModule { }
